module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('h3', [_vm._v("Backhaul Customer Summary")]), _c('br'), _vm._v(" "), _c('pie-chart', {
    attrs: {
      "data": _vm.chartSites,
      "thousands": ",",
      "legend": "right",
      "colors": _vm.colours,
      "download": true
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Customers")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.subscribers,
      "border": "",
      "stripe": "",
      "show-summary": "",
      "sum-text": "Totals",
      "summary-method": _vm.summaryFormatter
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "siteStatus",
      "label": "Site Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "subscriber",
      "label": "Customer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "provider",
      "label": "Provider"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "backhaulType",
      "label": "Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "backhaulStatus",
      "label": "Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sites",
      "label": "Sites",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatInt
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "entranceFee",
      "label": "Entrance Fee",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rowFee",
      "label": "ROW Fee",
      "sortable": "",
      "align": "right",
      "formatter": _vm.formatNum
    }
  })], 1), _vm._v(" "), _c('hr')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77e0cf9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/backhaul/BackhaulSubscriberSummary.vue
// module id = 1647
// module chunks = 0